export const MANA_BLUE_EXTRA_LIGHT = "#E5EEFF";
export const MANA_BLUE_LIGHT = "#BBD2FF";
export const MANA_BLUE = "#2562D8";
export const MANA_BLUE_DARK = "#1A2579";
export const MANA_GREY = "#F2F2F2";
export const MANA_YELLOW = "#F4D35E";
export const MANA_ACTIVE_GREEN = "#4CAF50";
export const MANA_COMPLETED_CARE_GREEN = "#1F7A3D";
export const MANA_UNRESPONSIVE_ORANGE = "#ED6C02";
export const MANA_CARE_NOT_STARTED_GREY = "#6B6B6B";

const Colors = {
  MANA_BLUE_LIGHT,
  MANA_BLUE,
  MANA_BLUE_DARK,
  MANA_GREY
};

export default Colors;

export type ThemeColor =
  | "manaBlueDark"
  | "manaBlue"
  | "manaBlueLight"
  | "manaBlueExtraLight"
  | "purpleCoral"
  | "manaYellow"
  | "manaActiveGreen"
  | "manaCompletedCareGreen"
  | "manaUnresponsiveOrange"
  | "manaCareNotStartedGrey";

export const themeColors: { [k in ThemeColor]: string } = {
  manaBlueDark: MANA_BLUE_DARK,
  manaBlue: MANA_BLUE,
  manaBlueLight: MANA_BLUE_LIGHT,
  manaBlueExtraLight: MANA_BLUE_EXTRA_LIGHT,
  manaYellow: MANA_YELLOW,
  purpleCoral: "#8d2995",
  manaActiveGreen: MANA_ACTIVE_GREEN,
  manaCompletedCareGreen: MANA_COMPLETED_CARE_GREEN,
  manaUnresponsiveOrange: MANA_UNRESPONSIVE_ORANGE,
  manaCareNotStartedGrey: MANA_CARE_NOT_STARTED_GREY
};
